import { useCallback, useState } from 'react';
import { Spin } from 'ui';
import { isSignUpOrganizationEnabled } from 'common/validators';
import { usePreselectPrimaryOrganization } from './hooks';
import type { PrimaryOrganizationOption } from './primary-organization-select';
import { SignUpOrganization } from './sign-up-organization';
import { type SignUpFormValues, SignUpUser } from './sign-up-user';

type P = {
  changeRequestId?: string;
  communityId?: string;
  invitationToken?: string;
  loading: boolean;
  onNavigateToCheckCode: ({ tokenToGetCode, tokenToLogin }: { tokenToGetCode?: string; tokenToLogin?: string }) => void;
  onSubmit: (values: SignUpFormValues) => void;
  onSuccessLogin: () => Promise<void>;
};

const SignUpContent = ({
  changeRequestId,
  communityId,
  invitationToken,
  loading,
  onNavigateToCheckCode,
  onSubmit,
  onSuccessLogin,
}: P) => {
  const [step, setStep] = useState<
    { option: 'organization' } | { option: 'user'; organization?: PrimaryOrganizationOption }
  >({ option: isSignUpOrganizationEnabled() ? 'organization' : 'user' });

  const { isLoading } = usePreselectPrimaryOrganization({
    communityId,
    onPrimaryOrganization: useCallback((organization: PrimaryOrganizationOption) => {
      setStep({ option: 'user', organization });
    }, []),
  });

  if (isLoading) {
    return <Spin />;
  }

  if (step.option === 'organization') {
    return (
      <SignUpOrganization
        onNext={(organization) => {
          setStep({ option: 'user', organization });
        }}
      />
    );
  }

  return (
    <SignUpUser
      changeRequestId={changeRequestId}
      initialOrganization={step.organization}
      invitationToken={invitationToken}
      loading={loading}
      onNavigateToCheckCode={onNavigateToCheckCode}
      onSubmit={onSubmit}
      onSuccessLogin={onSuccessLogin}
    />
  );
};

export default SignUpContent;
